import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import * as ROUTES from "../constants/routes";

export const PublicRoute = ( { isLoggedIn } ) => {
  return isLoggedIn ? <Navigate to={ROUTES.HOME} /> : <Outlet />;
}